import createRoute      from '@widesk-ui/tools/createRoute';
import DeliverableModel from '@models/shop/DeliverableModel';

export default createRoute.dashboard('/entertainments/:entertainmentId/deliverables', 'shop', 'DeliverableDashboard', DeliverableModel.localize());
